import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'lib-radio-field-wrapper',
  templateUrl: './radio-field-wrapper.component.html',
  styleUrls: ['./radio-field-wrapper.component.scss']
})
export class RadioFieldWrapperComponent extends FieldWrapper{
}
